import { gql } from '@apollo/client';

export const StrategyGuideStatuses = {
  DRAFT: {
    key: 'DRAFT',
    label: 'Draft',
    color: 'orange',
  },
  APPROVED: {
    key: 'APPROVED',
    label: 'Approved',
    color: 'green',
  },
  PENDING_CHANGES: {
    key: 'PENDING_CHANGES',
    label: 'Pending Changes',
    color: 'gold',
  },
};

export const strategyGuideFullAttributes = gql`
  {
    _id
    contactId
    contact {
      _id
      fullName
      primaryThumbnailUrl
    }
    version
    status
    fileId
    file {
      _id
      desc
      s3Key
      size
      filename
      contentType
      tags
      url
      previewUrl
      uploaded
      processed
      thumbnail {
        s3Key
        size
        filename
        contentType
        url
        height
        width
        sizeCode
      }
    }
    fileName
    notes
    notesText
    reviewedBy
    reviewedByUser {
      _id
      name
    }
    reviewedAt
    createdBy
    createdByUser {
      _id
      name
    }
    updatedBy
    createdAt
    updatedAt
  }
`;

export const strategyGuideListAttributes = gql`
  {
    _id
    contactId
    version
    status
    fileId
    fileName
    notes
    notesText
    reviewedBy
    reviewedAt
    createdBy
    createdAt
    updatedAt
  }
`;

export const strategyGuideForAdminQuery = gql`
  query StrategyGuideForAdmin($_id: ID!) {
    strategyGuideForAdmin(_id: $_id) ${strategyGuideFullAttributes}
  }
`;

export const allStrategyGuidesForAdminQuery = gql`
  query AllStrategyGuidesForAdmin(
    $first: Int
    $after: String
    $filters: StrategyGuideFiltersForAdmin
    $sortBy: [SortBy]
  ) {
    allStrategyGuidesForAdmin(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node ${strategyGuideListAttributes}
      }
    }
  }
`;

export const latestStrategyGuideForContactQuery = gql`
  query LatestStrategyGuideForContact($contactId: ID!) {
    latestStrategyGuideForContact(contactId: $contactId) ${strategyGuideFullAttributes}
  }
`;

export const strategyGuideVersionsForContactQuery = gql`
  query StrategyGuideVersionsForContact($contactId: ID!) {
    strategyGuideVersionsForContact(contactId: $contactId) ${strategyGuideFullAttributes}
  }
`;

export const createStrategyGuideMutation = gql`
  mutation CreateStrategyGuide($strategyGuide: StrategyGuideCreateInput!) {
    createStrategyGuide(strategyGuide: $strategyGuide) {
      strategyGuide ${strategyGuideFullAttributes}
      historyIds
    }
  }
`;

export const updateStrategyGuideMutation = gql`
  mutation UpdateStrategyGuide($strategyGuide: StrategyGuideUpdateInput!) {
    updateStrategyGuide(strategyGuide: $strategyGuide) {
      strategyGuide ${strategyGuideFullAttributes}
      historyIds
    }
  }
`;

export const deleteStrategyGuideMutation = gql`
  mutation DeleteStrategyGuide($_id: ID!) {
    deleteStrategyGuide(_id: $_id) {
      deletedId
      historyIds
    }
  }
`;

export const reviewStrategyGuideMutation = gql`
  mutation ReviewStrategyGuide($review: StrategyGuideReviewInput!) {
    reviewStrategyGuide(review: $review) {
      strategyGuide ${strategyGuideFullAttributes}
      historyIds
    }
  }
`;

export const strategyGuideUpdatesForAdminSubscription = gql`
  subscription StrategyGuideUpdatesForAdmin($filters: StrategyGuideUpdateFiltersForAdmin!) {
    strategyGuideUpdatesForAdmin(filters: $filters) {
      crud
      id
      new ${strategyGuideFullAttributes}
      old ${strategyGuideFullAttributes}
    }
  }
`;

export const extractStrategyGuideForAdmin = (data) =>
  data && data.strategyGuideForAdmin;
export const extractLatestStrategyGuideForContact = (data) =>
  data && data.latestStrategyGuideForContact;
export const extractStrategyGuideVersionsForContact = (data) =>
  data && data.strategyGuideVersionsForContact;
